import React from "react";
import { SupportForm } from "./Components/SupportForm";
import { useHistory } from "react-router-dom";
import Page from "../UI/Elements/Page";
import { Box } from "@material-ui/core";
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    minHeight: 'calc(100vh - 314px)',
    padding: '3.5rem 1.25rem 4rem',
    // background:
    //   'radial-gradient(circle at 18% 18%, rgba(255, 168, 154, 0.42), transparent 55%),' +
    //   'radial-gradient(circle at 82% 22%, rgba(244, 201, 93, 0.30), transparent 52%),' +
    //   'radial-gradient(circle at 72% 86%, rgba(61, 30, 92, 0.14), transparent 58%),' +
    //   'linear-gradient(180deg, #FFE4E1 0%, #FFF8F0 100%)',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    [theme.breakpoints.down('xs')]: {
      padding: '2.5rem 0.75rem 3rem',
    },
  },
  paper: {
    padding: theme.spacing(6),
    borderRadius: '30px',
    margin: 'auto',
    maxWidth: '80%',
    backgroundColor: 'rgba(255, 255, 255, 0.86)',
    backdropFilter: 'blur(10px) saturate(140%)',
    WebkitBackdropFilter: 'blur(10px) saturate(140%)',
    border: '1px solid rgba(255, 255, 255, 0.65)',
    boxShadow: '0 24px 60px rgba(61, 30, 92, 0.10)',
    [theme.breakpoints.down('xs')]: {
      maxWidth: '100%',
      padding: '3rem',
   },
  }
}));

const Contact = () => {
  const classes = useStyles();
  const history = useHistory();

  return (
    <div className={classes.root}>
      <Page>
        <Paper className={classes.paper}>
          <Grid container spacing={6}>
            <Grid item xs={12} sm={6}>
              <h1>Opmerking, vraag of suggestie?</h1> 
              <p>Neem gerust contact met ons op via het formulier.</p>
              <Box my={4}>
                <h3>Meteen weten hoe AllesBon werkt?</h3>    
                <Button style={{marginTop: '1rem'}}variant="outlined" className="customButton2" onClick={() => history.push("/demo")}>DEMO</Button>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6}>
              <SupportForm onClose={() => history.go(0)}/>
            </Grid>
          </Grid>
        </Paper>
      </Page>
    </div>
  );
};

export default Contact;
